/** Listing reserved by seller (Vinted-style). */

export type ListingReservationFields = {
  is_reserved?: boolean
  reserved_for_user_id?: number | null
  owner_id?: number
  is_sold?: boolean
}

export function isListingReserved(listing: ListingReservationFields): boolean {
  return Boolean(listing.is_reserved && !listing.is_sold)
}

/** Buyer cannot purchase / offer when reserved for someone else (or generally). */
export function reservationBlocksBuyer(
  listing: ListingReservationFields,
  userId: number | undefined | null,
): boolean {
  if (!isListingReserved(listing)) return false
  if (userId == null) return true
  if (listing.owner_id === userId) return false
  if (listing.reserved_for_user_id == null) return true
  return listing.reserved_for_user_id !== userId
}
